import React from 'react';
import PropTypes from 'prop-types';
import TileView, { TileViewProps, TileViewTypeProp } from '../TileView';

const UserTypeCheck = ({ allowed = [], currentUser, children }) => {
  // for now nothing specified means all roles allowed
  const match =
    allowed.length === 0 || allowed.indexOf(currentUser.type) !== -1;
  if (typeof children === 'function') {
    return children(match);
  }
  return match ? React.Children.only(children) : null;
};

const LandingView = ({ tiles, viewType, style, currentUser }) => (
  <div
    style={Object.assign(
      { display: 'flex', flexFlow: 'row wrap', justifyContent: 'center' },
      style
    )}
  >
    {tiles.map(tile => (
      <UserTypeCheck
        key={tile.key}
        allowed={tile.roles}
        currentUser={currentUser}
      >
        <TileView viewType={viewType} {...tile} showAvatar={false} />
      </UserTypeCheck>
    ))}
  </div>
);

LandingView.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(TileViewProps)),
  viewType: TileViewTypeProp,
  style: PropTypes.object,
  currentUser: PropTypes.object,
};

export default LandingView;



// WEBPACK FOOTER //
// ./src/common/components/LandingView/index.js